import { useAuth0 } from "@auth0/auth0-react";
import CircularProgress from "@mui/material/CircularProgress";
import FinancialSetting from "Lib/API/FinanceSetting/FinanceSetting";
import deceasedPhoto from "assets/icons/speaker.svg";
import React, { useEffect } from "react";
import FinanceService from "../../../../Lib/API/Finance";
import ShareDocumentsHeader from "./ShareDocumentsHeader";

import { getRandColor } from "components/ShareDocuments/Emails/emailRandomColor";
import Templates from "components/ShareDocuments/Templates/index";
import { StaticTemplate } from "./StaticTemplete/index";

import PreSchoolService from "Lib/API/PreSchool";
import Button from "components/button/Button";
import useTemplateReplacement from "hook/useTemplateReplacement ";
import { useState } from "react";
import { toastr } from "react-redux-toastr";
import "./index.scss";

const ShareDocumentsModal = ({
  closeModal,
  documentsIds,
  documentType,
  defaultEmail,
  isMultiple,
  isMultipleTypes,
  data,
  accountId,
  accountName,
  chargeId,
  participantId,
  type,
  participantsIds,
  copyPaymentLink,
  sharePaymentType,
  disablePaymentLink = false,
  payload = {},
}) => {
  const { getAccessTokenSilently } = useAuth0();
  const [savedEmails, setSavedEmails] = useState([]);
  const [templateId, setTemplateId] = useState(null);
  const [sendEmailsLoading, setSendEmailsLoading] = useState(false);
  const [templateContent, setTemplateContent] = useState(null);
  const [getTemplateLoading, setGetTemplateLoading] = useState(false);
  const [isCopied, setIsCopied] = useState(false);

  const toastMessages = {
    single: {
      success: "Email send successfully",
      error: "Error while sending email",
    },
    multiple: {
      success: "Emails send successfully",
      error: "Error while sending emails",
    },
  };

  const buttons = [
    {
      id: "cancel",
      label: "Cancel",
      action: closeModal,
      className: "share-documents__content__actions-btn cancel",
      variant: "secondary-light",
    },
    {
      id: "send",
      label: "Send Now",
      action: () => {
        if (
          !isMultiple &&
          (savedEmails.filter((item) => item.type === "to").length === 0 ||
            sendEmailsLoading)
        )
          return;
        submitHandler();
      },
      className: "share-documents__content__actions-btn submit",
      disabled:
        !isMultiple &&
        (savedEmails.filter((item) => item.type === "to").length === 0 ||
          sendEmailsLoading),
      loading: sendEmailsLoading,
      variant: "primary",
    },
  ];

  const SendDocumentHandler = async (token) => {
    const toEmails = [];
    const ccEmails = [];
    const bccEmails = [];

    savedEmails.forEach((item) => {
      if (item.type === "to") {
        toEmails.push(item.email);
      } else if (item.type === "cc") {
        ccEmails.push(item.email);
      } else if (item.type === "bcc") {
        bccEmails.push(item.email);
      }
    });
    if (type === "sharePaymentLink") {
      const sharedPaymentData = {
        accountId: accountId,
        chargeId: chargeId,
        participantId: participantId,
        toEmails: toEmails,
        ccEmails: ccEmails,
        bccEmails: bccEmails,
      };

      // Share Payment Link Api
      await FinanceService.sendSharePaymentLink(token, sharedPaymentData)
        .then((response) => {
          toastr.success(toastMessages.single.success);
        })
        .catch((err) => {
          toastr.error(err?.data?.message || toastMessages.single.error);
        })
        .finally(() => {
          closeModal(true);
          setSendEmailsLoading(false);
        });
    } else if (type === "Document") {
      await FinanceService.sendDocumentShare(token, {
        templateId: templateId,
        documentId: documentsIds[0],
        toEmails: toEmails,
        ccEmails: ccEmails,
        bccEmails: bccEmails,
      })
        .then((response) => {
          toastr.success(toastMessages.single.success);
        })
        .catch((err) => {
          toastr.error(err?.data?.message || toastMessages.single.error);
        })
        .finally(() => {
          closeModal(true);
          setSendEmailsLoading(false);
        });
    } else if (type === "updatePayment") {
      const updatePayment = {
        accountId: accountId,
        toEmails: toEmails,
        ccEmails: ccEmails,
        bccEmails: bccEmails,
      };

      // Share Payment Link Api
      await FinanceService.updatePaymentMethod(token, updatePayment)
        .then((response) => {
          toastr.success(toastMessages.single.success);
        })
        .catch((err) => {
          toastr.error(err?.data?.message || toastMessages.single.error);
        })
        .finally(() => {
          closeModal(true);
          setSendEmailsLoading(false);
        });
    }
  };
  const SendDocumentBulkHandler = async (token) => {
    const data = {
      ...payload,
      documentIds: documentsIds,
    };

    if (!isMultipleTypes) {
      data.templateId = templateId;
    }

    await FinanceService.sendDocumentBulkShare(token, data)
      .then((response) => {
        toastr.success(toastMessages.multiple.success);
      })
      .catch((err) => {
        toastr.error(err?.data?.message || toastMessages.multiple.error);
      })
      .finally(() => {
        closeModal(true);
        setSendEmailsLoading(false);
      });
  };
  const sendMultiplePaymentHandler = async (token) => {
    const payload = {
      participantsIds: participantsIds,
    };
    const sharePayment =
      sharePaymentType === "form"
        ? PreSchoolService.sendFormParticipantPayment
        : PreSchoolService.sendEventParticipantPaymentEvent;
    await sharePayment(token, payload)
      .then((response) => {
        toastr.success(toastMessages.multiple.success);
      })
      .catch((err) => {
        toastr.error(err?.data?.message || toastMessages.multiple.error);
      })
      .finally(() => {
        closeModal(true);
        setSendEmailsLoading(false);
      });
  };

  const submitHandler = async () => {
    const token = await getAccessTokenSilently();
    setSendEmailsLoading(true);
    if (isMultiple) {
      if (type === "sharePaymentLink") {
        return sendMultiplePaymentHandler(token);
      }
      return SendDocumentBulkHandler(token);
    }
    return SendDocumentHandler(token);
  };

  const { content } = useTemplateReplacement(
    templateContent,
    getAccessTokenSilently,
    type === "Document" ? "document" : "",
    false
  );

  const getTemplateByTypeHandler = async () => {
    setGetTemplateLoading(true);
    const token = await getAccessTokenSilently();
    try {
      const response = await FinancialSetting.getTemplateByType(
        token,
        documentType
      );
      const content = response?.result?.htmlContent;
      setTemplateContent(content || null);
      setTemplateId(response?.result?._id);
    } catch (error) {
      toastr.error("Error", error?.data?.message ?? "Something Went Wrong");
    } finally {
      setGetTemplateLoading(false);
    }
  };

  const displayDefaultEmailHandler = async () => {
    const emails = defaultEmail.map((item) => ({
      email: item,
      type: "to",
      image: item.charAt(0).toUpperCase(),
      color: getRandColor(),
    }));
    setSavedEmails((prev) => [...prev, ...emails]);
  };

  useEffect(() => {
    if (defaultEmail?.length && !isMultiple) {
      displayDefaultEmailHandler();
    }
    if (isMultipleTypes) return;
    getTemplateByTypeHandler();
  }, []);

  const handleCopy = () => {
    if (!copyPaymentLink) return;
    navigator.clipboard.writeText(copyPaymentLink);
    setIsCopied(true);
    setTimeout(() => setIsCopied(false), 2000);
  };

  return (
    <div className="share-documents">
      <div className="share-documents__image">
        <img src={deceasedPhoto} alt="deceased" />
      </div>
      <div className="share-documents__content">
        <div className="share-documents__content__wrapper">
          <ShareDocumentsHeader
            setSavedEmails={setSavedEmails}
            savedEmails={savedEmails}
            closeModal={closeModal}
            isMultiple={isMultiple}
            title={isMultiple ? "Send Letter" : "Communication Email"}
          />
          <hr />
          {isMultipleTypes ? (
            <div className="share-documents-text">
              The member will receive a separate email for each of the{" "}
              {type === "sharePaymentLink" ? "payment " : "documents "}
              you selected
            </div>
          ) : (
            <div className="share-documents__content__templates">
              <Templates
                templateContent={content}
                isLoading={getTemplateLoading}
                showTitle={type === "sharePaymentLink" ? false : true}
                disableLinks={disablePaymentLink || sharePaymentType === "form"}
              />
            </div>
          )}
        </div>
        <div className="share-documents__content__actions">
          {copyPaymentLink && (
            <div className="share-documents__content__actions-left">
              <Button
                className="position-relative"
                onClick={handleCopy}
                variant="secondary-light"
                size="md"
              >
                Copy Payment Link
                {isCopied && (
                  <div className="copy-value__hint copy-payment__hint">
                    {isCopied ? "Copied" : "Copy"}
                  </div>
                )}
              </Button>
            </div>
          )}
          {buttons.map((button) => (
            <Button
              className={button.className}
              key={button.id}
              onClick={() => button.action()}
              disabled={button.disabled}
              variant={button.variant}
              size="md"
            >
              {button.loading ? (
                <div className="d-flex">
                  <CircularProgress
                    size={22}
                    style={{
                      color: "#ffffff",
                    }}
                  />
                </div>
              ) : (
                button.label
              )}
            </Button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ShareDocumentsModal;
